import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../components/tabon/Logo";
import { api, formatError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    venue_name: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      toast.success(`Venue "${data.venue.name}" created — code ${data.venue.venue_code}`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  const field = (label, key, type = "text", placeholder = "") => (
    <div>
      <label className="text-xs font-bold uppercase tracking-wider text-[#A0A0A0] mb-1.5 block">
        {label}
      </label>
      <input
        data-testid={`signup-${key}-input`}
        type={type}
        value={form[key]}
        onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        required
        placeholder={placeholder}
        className="w-full bg-[#0A0A0A] border border-white/10 rounded-lg px-4 py-3 min-h-[44px] text-white placeholder:text-[#6B6B6B] focus:border-[#9D00FF] focus:ring-1 focus:ring-[#9D00FF]/40"
      />
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-4 tb-hero-gradient">
      <div className="absolute inset-0 tb-grid-bg opacity-40 pointer-events-none" />
      <div className="relative w-full max-w-md tb-fade-up">
        <div className="flex flex-col items-center mb-8">
          <Logo size="xl" />
          <p className="text-[#A0A0A0] mt-3 text-sm italic">Turn every visit into the next one.</p>
        </div>
        <div className="bg-[#1A1A1A] border border-white/10 rounded-xl p-7 shadow-2xl">
          <h1 className="text-2xl font-bold mb-1">Create Your Venue</h1>
          <p className="text-sm text-[#A0A0A0] mb-6">Onboard in under a minute</p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {field("Venue Name", "venue_name", "text", "e.g. The Copper Lounge")}
            {field("Your Name", "name", "text", "Full name")}
            {field("Email", "email", "email", "you@venue.com")}
            {field("Password", "password", "password", "At least 6 characters")}
            <button
              type="submit"
              disabled={loading}
              data-testid="signup-submit-button"
              className="tb-glow bg-[#9D00FF] hover:bg-[#8C00E6] disabled:opacity-60 text-white font-semibold rounded-lg py-3 min-h-[44px] transition-all active:scale-[0.99]"
            >
              {loading ? "Creating…" : "Create Venue"}
            </button>
          </form>
          <div className="text-center text-sm text-[#A0A0A0] mt-5">
            Already have an account?{" "}
            <Link to="/login" className="text-[#9D00FF] font-semibold hover:underline">
              Sign in
            </Link>
          </div>
        </div>
        <div className="text-center text-xs text-[#A0A0A0] mt-6">
          Powered by <span className="text-white">TabOn</span> · tabon.app
        </div>
      </div>
    </div>
  );
}
